import { arrowUpSmallIcon } from '@workday/canvas-system-icons-web'
import { createIcon } from './create-icon'
import { canvasIconPaths } from './canvasIconPaths'

export const SortUp = createIcon({
  displayName: 'SortUp',
  viewBox: '0 0 24 24',
  paths: [
    {
      d: 'M18.7101 16.29C18.3201 15.9 17.6901 15.9 17.3001 16.29L16.0101 17.58V11.99C16.0101 11.44 15.5601 10.99 15.0101 10.99C14.4601 10.99 14.0101 11.44 14.0101 11.99V17.58L12.7201 16.29C12.3301 15.9 11.7001 15.9 11.3101 16.29C10.9201 16.68 10.9201 17.31 11.3101 17.7L14.3101 20.7C14.4001 20.79 14.5101 20.87 14.6401 20.92C14.7601 20.97 14.8901 21 15.0201 21C15.1501 21 15.2801 20.97 15.4001 20.92C15.5201 20.87 15.6301 20.8 15.7301 20.7L18.7301 17.7C19.1201 17.31 19.1201 16.68 18.7301 16.29H18.7101Z',
      opacity: 0.35
    },
    'M5.29004 7.70999C5.68004 8.09999 6.31004 8.09999 6.70004 7.70999L7.99004 6.41999V12.01C7.99004 12.56 8.44004 13.01 8.99004 13.01C9.54004 13.01 9.99004 12.56 9.99004 12.01V6.40999L11.28 7.69999C11.67 8.08999 12.3 8.08999 12.69 7.69999C13.08 7.30999 13.08 6.67999 12.69 6.28999L9.69004 3.28999C9.60004 3.19999 9.49004 3.11999 9.36004 3.06999C9.24004 3.01999 9.11004 2.98999 8.98004 2.98999C8.85004 2.98999 8.72004 3.01999 8.60004 3.06999C8.48004 3.11999 8.37004 3.18999 8.27004 3.28999L5.27004 6.28999C4.88004 6.67999 4.88004 7.30999 5.27004 7.69999L5.29004 7.70999Z'
  ],
  canvasPaths: canvasIconPaths(arrowUpSmallIcon)
})
